<template>
  <v-container fluid>
    <v-row class="pt-2">
      <h2>Добро пожаловать на сайт межкафедральной учебно-научной лаборатории «Гербарий-SV»! </h2>
      <p>Здесь вы найдете информацию <router-link :to="urlsAtDescription.aboutLab">о нашей лаборатории</router-link>, <router-link :to="urlsAtDescription.collections">коллекциях</router-link> и <router-link :to="urlsAtDescription.articles">публикациях</router-link>. Мы всегда открыты для сотрудничества и использованию наших коллекций в научных целях.</p>
      <p>На текущий момент в систему добавлено:</p>
    </v-row>

    <v-row class="pt-2 mt-0">
      <v-col sm='4' class='pa-0'>
        <v-card tile class='pa-2'>
          Образцов: {{ examplesCount }}
        </v-card>
      </v-col>

      <v-col sm='4' class='pa-0'>
        <v-card tile class='pa-2'>
          Сканов: {{ scansCount }}
        </v-card>
      </v-col>

      <v-col sm='4' class='pa-0'>
        <v-card tile class='pa-2'>
          Видов: {{ speciesCount }}
        </v-card>
      </v-col>
    </v-row>

    <v-row class="pt-2">
      <v-carousel
          show-arrows-on-hover
          cycle
          hide-delimiter-background
          height="auto"
      >
        <v-carousel-item
            v-for="(slide, i) in slides"
            :key="i"
        >
          <img :src="slide.img" style="width: 100%; height: 100%; object-fit: contain;"/>
        </v-carousel-item>
      </v-carousel>
    </v-row>

    <v-row class="pt-2" v-if="newsItems && newsItems.length > 0">
      <h2>Последние новости</h2>
    </v-row>
    <v-row class="mx-n5" v-if="newsItems && newsItems.length > 0">
      <v-col class='py-2 px-2 d-flex' cols='12' sm='6' v-for="(news, index) in newsItems" :key='index'>
        <v-card tile class='d-flex flex-column'>
          <v-card-title class='text-break'>{{ news.title }}</v-card-title>
          <v-card-subtitle v-if='news.author' class='text-break'>{{ news.author }}</v-card-subtitle>
          <v-card-text class='text-break'>{{ news.summary }}</v-card-text>
          <v-card-text class="mt-auto">
            Дата публикации: {{news.createAt}}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="pt-2">
      <h2>Наши контакты</h2>
    </v-row>
    <v-row class="mx-n5">
      <v-col cols='12' sm='6' class='py-2 px-2'>
        <YandexMaps class="ma-0" :zoom="16" :coordinates="this.coordinatesHerb" style="height: 600px;"/>
      </v-col>
      <v-col cols='12' sm='6' class='py-2 px-2'>
        <v-row v-for="(item, index) in contactsBlobArray" :key="index" :class="{'mt-0': index !== 0}">
          <v-col>{{item}}</v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import YandexMaps from "@/components/YandexMaps.vue";
import { fetchNews } from '@/services/newAPI';
import { fetchStatisticsExhibit } from "@/services/exhibitAPI";

export default {
  components: {YandexMaps},
  data() {
    return {
      examplesCount: 0,
      scansCount: 0,
      speciesCount: 0,

      coordinatesHerb: [53.222643, 50.173038],
      contactsBlobArray: [
        'Адрес: 443011, г. Самара, ул. Академика Павлова, д. 1, Самарский национальный исследовательский университет имени академика С.П. Королева, к. 22, лаб. 607, 612',
        'Тел.: 8 (846) 334-54-43',
        'E-mail: herbarium-smr@yandex.ru'
      ],
      slides: [
        { img: require('../images/mainPage/1.jpg'), },
        { img: require('../images/mainPage/2.jpg'), },
        { img: require('../images/mainPage/3.jpg'), },
        { img: require('../images/mainPage/4.jpg'), },
        { img: require('../images/mainPage/5.jpg'), },
        { img: require('../images/mainPage/6.jpg'), },
      ],
      urlsAtDescription: {
        aboutLab: '/lab',
        collections: '/collections',
        articles: '/articles'
      },
      newsItems: []
    }
  },
  methods: {
    async getStatistic() {
      const statistic = (await fetchStatisticsExhibit()).result;
      this.examplesCount = statistic.exhibitsCount;
      this.scansCount = statistic.exhibitsPhotosCount;
      this.speciesCount = statistic.speciesCount;
    },
    async getNews() {
      fetchNews(null, null, null, 0)
          .then((data) => {
            this.newsItems = data.body.map(item => {
              return {
                title: item.title,
                author: item.author,
                summary: item.content.length > 200 ? `${item.content.substring(0, 200)}...` : item.content,
                createAt: item.createAt
              };
            });
          })
          .catch(error => {
            console.log(error);
          })
    }
  },
  async mounted() {
    this.isLoading = true
    await this.getStatistic();
    await this.getNews();
    this.isLoading = false
  },
}
</script>

<style scoped>

</style>